import { environment } from 'src/environments/environment';

export enum CoolerType {
  CASER12 = '12 Caser',
  CASER15_5 = '15.5 Caser',
  CASER30 = '30 Caser',
  CASER45 = '45 Caser',
  CASER45_15_5 = '45 Caser (15.5)',
  CASER45_30 = '45 Caser (30)',
}

export const CONFIG = {
  CMTOPIXCEL: 37.8,
  CMTOPIXCELHALF__: 18.9,
  CMTOPIXCELHALF___: 9.4,
  CMTOPIXCELHALF____: 4.7,
  CMTOPIXCELHALF: 4.7,
  PLACEHOLDER_HEIGHT_CLEARANCE: 30,
  SHELF_HEIGHT_CLEARANCE: 10,
  MMTOPIXCEL: 0.15,
  WIDTHCONSTANT: 8,
  HEIGHTCONSTANT: 8,
  NUMBER_SUFFIX: ['', 'K', 'M', 'B', 'T'],
  DECIMALPLACE: 1,
  BLACK_HEX_CODE: '#000000',
  DOMAINPATH: environment.domain_name,
  LANDINGPAGEPATH: environment.domain_name + '/landing-page',
  COOLER: {
    CASER12: '12 Caser',
    CASER15: '15.5 Caser',
    CASER30: '30 Caser',
    CASER45: '45 Caser',
  },
  BASE_MAX_HEIGHT: 48,
  BASE_MAX_WIDTH: 120,
  SIZE_MULTIPLIERS: {
    [CoolerType.CASER12]: 1,
    [CoolerType.CASER15_5]: 1.25,
    [CoolerType.CASER30]: 1.67,
    [CoolerType.CASER45]: 2.08,
    [CoolerType.CASER45_15_5]: 1.25,
    [CoolerType.CASER45_30]: 1.67,
  },
  PATH: {
    LOGIN: 'login',
    ADMINPANEL: 'admin-panel',
    PLANOGRAMS: 'planogram/planograms',
    PUBLISHED: 'published',
    DRAFT: 'drafts',
    EMPTY: '',
    CPCMASTER: '',
    NEWPLANOGRAM: 'planogram/new-planogram/',
    PLANOGRAM: 'planogram/planogram/',
    COMPAREPLANOGRAM: 'planogram/compare-planograms/',
    AUTHRESPONSE: 'planogram/auth-response',
    LANDING_PAGE: 'landing-page',
    GUIDELINES_INPUT: 'planogram/guidelines-input/',
    ADMIN_UPDATE_GUIDELINES: 'admin-update-guidelines',
    ADMIN_DATA_UPDATE: 'admin-data-update',
    ADMIN_USER_ANALYTICS: 'admin-user-analytics',
    ADMIN_GUIDELINES_INPUT: 'planogram/admin-guidelines-input/',
    ADMIN_SETUP_SCREEN: 'planogram/admin-planogram/',
    ADMIN_SETUP_SCREEN_NEW: 'planogram/admin-planogram',
    ADMIN_CUSTOM_PLANOGRAM_NEW: 'admin/custom-planogram',
    ADMIN_CUSTOM_PLANOGRAM: 'admin/custom-planogram/',
    CUSTOM_PLANOGRAM_LIBRARY: 'admin/custom-palongram-library',
    DOCS:"docs"
  },
  API: {
    SKUGETALL: 'api/v1/sku/getplanogramspecificsku',
    GETNPD: 'api/planogram/get_npds/',
    GETPICOSSKUS: 'api/v1/sku/getplanogramspecificpicos',
    GETSPECIFICSKU: 'api/v1/sku/getspecific',
    GETSPECIFICPLANOGRAM: 'api/v1/planogram/planogram',
    CHECKUNIQUEPLANOGRAM: 'api/planogram/unique/',
    GETPLANOGRAMBASEDATA: 'api/planogram/fetch_dropdown_data/',
    GETPLANOGRAMS: 'api/planogram/get_planogram_list/',
    SAVEPLANAGRAM: 'api/planogram/add/',
    EDITPLANAGRAM: 'api/v1/planogram/editbasedata',
    DELETEPLANAGRAM: 'api/planogram/delete/',
    GETPLANOGRAMSAVEDBASEDATA: 'api/planogram/select/',
    COOLERTEMPLATEBASEDATA: 'api/v1/cooler/getbasedatatemplate',
    SEPECIFICSCREENCONFIG: 'getspecificscreenconfig',
    CHECKUNIQUETEMPLATE: 'api/v1/cooler/checkuniquetemplatename',
    SAVETEMPLATE: 'api/v1/cooler/savebasetemplatedata',
    EDITTEMPLATE: 'api/v1/cooler/editbasetemplatedata',
    GETSAVEDTEMPLATEDATA: 'api/v1/cooler/getsavedbasetemplatedata',
    GETALLTEMPLATES: 'api/v1/cooler/getalltemplates',
    SAVETEMPLATETOPLANOGRAM: 'api/v1/cooler/savetemplatetoplanogram',
    EDITCOOLERFACING: 'api/v1/cooler/editfacings',
    SAVEPLANOGRAMSKUPLACEMENT: 'api/planogram/analysis_kpis/',
    PUBLISHPLANOGRAM: 'api/planogram/publish/',
    COMPAREPLANOGRAM: 'api/planogram/planogram_comparison/',
    AUTOFILLSKUS: 'api/v1/sku/autofill',
    RECOMMANDATIONS: 'api/v1/sku/recommendations',
    ADDITIONALINFO: 'api/v1/cooler/getadditionalinfo',
    CALCULATETHROUGHPUT: 'api/v1/sku/calculatethroughput',
    VERTICALAUTOFILL: 'api/v1/sku/verticalautofill',
    COPYPLANOGRAM: 'api/v1/planogram/cloneplanogram',
    ADMINGETCOOLERDATA: 'api/adminpanel/get_cooler_data/',
    ADMINPANELCOOLERUPLOAD: 'api/adminpanel/upload_cooler_data/',
    ADMINGETSKUDATA: 'api/adminpanel/get_sku_data/',
    ADMINPANELSKUUPLOAD: 'api/adminpanel/upload_sku_data/',
    ADMINUPLOADBASEDATA: 'api/adminpanel/upload_base_data/',
    ADMINFETCHBASEDATA: 'api/adminpanel/get_base_data/',
    SAVEUSERTOKEN: 'authentication/save_token/',
    COMPARABLEPLANOGRAMS: 'api/planogram/comparable_planograms/',
    REVIEWSKUFACINGS: 'api/planogram/fetch_facings/',
    SETUPSAVEASDRAFT: 'api/planogram/save_details/',
    GETREVIEWKPIS: 'api/planogram/review_kpis/',
    GETLHSSKULIST: 'api/planogram/get_sku_list/',
    SAVECUSTOMPLANOGRAM: 'api/planogram/save_customized_cooler/',
    CREATEBASEPLANOGRAM: 'api/planogram/create_base_planogram/',
    GETCOOLERINFO: 'api/planogram/cooler_info/',
    GETSAVEDPLANOGRAMINFO: 'api/planogram/fetch_no_of_saved_planograms/',
    GETGUIDELINESINPUT: 'api/planogram/guidelines_input/',
    INCORPORATENPDS: 'api/planogram/incorporate_npds/',
    UPDATEPLANOGRAM: 'api/planogram/update_planogram/',
    GETUSERINFO: 'api/generic/get_user_info/',
    ADMINUPDATEDATA: 'api/adminpanel/get_dataset_details/',
    SAVE_BOTTLER_QUERY: 'api/generic/save_bottler_query/',
    ADMINUSERANALYTICS: 'api/generic/get_user_analytics/',
    ADMINUSERQUERIES: 'api/adminpanel/fetch_bottler_queries/',
    ADMINMARKRESOLVE: 'api/generic/mark_resolved/',
    GETGUIDELINESLIBRARYDATA: 'api/adminpanel/fetch_versions/',
    GETVERSIONEDGUIDELINES: 'api/adminpanel/fetch_versioned_guidelines/',
    SETLOCKEDGUIDELINESL: 'api/adminpanel/lock_all_guidelines/',
    CREATEPLANOGRAMVERSION: 'api/adminpanel/create_planogram_version/',
    CREATECUSTOMPLANOGRAM: 'api/planogram/create_customized_cooler/',
    FETCHCUSTOMPLANOGRAMS: 'api/planogram/fetch_custom_planograms/',
    UPDATEMINIMUMFACINGS: 'api/adminpanel/update_minimum_facings/',
  },
  PLANOGRAMSTATUS: {
    ACTIVE: 'Completed',
    INACTIVE: 'Inactive',
    DRAFT: 'In-progress',
  },
  COOLERFACINGMODE: {
    BATCH: 'batch',
    INDIVIDUAL: 'individual',
  },
  COOLERTRAFFICDIRECTIONS: {
    DOOR1: ['Left', 'Right'],
    DOOR2: ['Center'],
    DOOR3: ['Left Center', 'Right Center'],
  },
  ICSHELFMAXVOLUME: 750,
  SKU_PLACEMENT_WARNING: {
    COPY_SKU_TO_ADJACENT: 'No adjacent space remaining.',
    SKU_DROP_ERROR_MSG: 'No sufficient space remaining for target SKU.',
    SKU_DROP_IN_WRONG_SHELF:
      'SKU is not added as it does not placed in right shelf.',
    SKU_ADDITION_IN_WRONG_SHELF:
      'Some SKUs are not added as they do not placed in right shelf.',
    SKU_REPLACEMENT_IN_WRONG_SHELF:
      'Some SKUs are not replaced as they do not placed in right shelf.',
    FCSKUERRORMESSAGE:
      'SKU cannot be added as the shelf is reserved for FC SKUs only.',
    ICSKUERRORMESSAGE:
      'SKU cannot be added as the shelf is reserved for IC SKUs only.',
    FCICSKUERRORMESSAGE:
      'SKUs cannot be added as the shelf is reserved for IC/FC SKUs only.',
  },
  COOLEROVERSHOOTING: {
    SHELFWIWIDTH: 'overshooting permissible internal width.',
    SHELFHEIGHT: 'overshooting permissible internal height.',
  },
  VERTICAL_BLOCK_BRAND_ERROR:
    'Selected brand does not have IC/FC SKUs, please select additional brands to complete the block.',
  NPD_SELECTION_OPTIONS: {
    Yes: 1,
    No: 0,
  },
};
